export default "__VITE_ASSET__CnCjJG3c__"